// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3EFTu","savePackageButton":"ClientWallet_savePackageButton__WKw-1"};